import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'suppliers_subcontractors_1'

export const dataPointDefinition = {
  retracedId: 'suppliers_subcontractors_1',
  name: 'Suppliers/Subcontractors',
  description:
    'The intent of this option selection is to understand if the facility has written policies and/or procedures in place on the topic of "suppliers/subcontractors", which can include risk identification of suppliers/subcontractors, supply chain due diligence, supplier/subcontractor requirements for resp',
  meta: {
    slcpMeta: {
      key: 'ms-1--2-18x',
      number: 'MS-PLA-4-18',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ms-1--2-18x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 32240,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
